import React, { useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import GroupWrapper from '../Wrappers/GroupWrapper';
import {
  useTableState,
  useTableDispatch,
} from '../../../context/TableSchemaBuilderContext';

const LockGroup = () => {
  const dispatch = useTableDispatch();
  const { ui, schema } = useTableState();

  const currentCell = ui?.selectedCells?.[0];
  const isLocked = schema?.cells?.[currentCell]?.isLocked || false;

  const handleLockToggle = useCallback(() => {
    if (currentCell) {
      dispatch({
        type: 'TOGGLE_CELL_LOCK',
        payload: {
          cellId: currentCell,
        },
      });
    }
  }, [currentCell, dispatch]);

  return (
    <GroupWrapper label="Lock">
      <Tooltip title={isLocked ? 'Unlock Cell' : 'Lock Cell'}>
        <IconButton
          size="small"
          onClick={handleLockToggle}
          color={isLocked ? 'primary' : 'default'}
          disabled={!currentCell}
        >
          {isLocked ? (
            <LockIcon fontSize="small" />
          ) : (
            <LockOpenIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </GroupWrapper>
  );
};

export default LockGroup;
